import React, { useMemo } from "react";

import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { BigTile, TextComponent } from "../../../../Common/Tile";

const useStyles = makeStyles()((theme) => ({
  NoData: {
    display: "flex",
    justifyContent: "center",
  },
}));

function Tile({ loading, sources, navigateToDashboard }) {
  const { classes } = useStyles();

  const $sortedSources = useMemo(
    () => [...sources.sort((a, b) => a["displayName"].localeCompare(b["displayName"]))],
    [sources]
  );

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid sx={{ mb: 1, display: "flex", alignItems: "center" }} size={12}>
        <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
          <Grid container spacing={4} direction="row">
            {!loading && sources.length > 0 ? (
              $sortedSources.map(
                ({ id, name, displayName, description, fieldCount, connectionName, type, datasetType }) => {
                  return (
                    <Grid
                      key={id}
                      sx={{ mb: 2 }}
                      size={{
                        xs: 12,
                        sm: 6,
                        md: 4,
                        xl: 3,
                      }}
                    >
                      <BigTile
                        configData={{
                          dataId: "ds" + name,
                          iconWidth: 6,
                          clickEvent: () => navigateToDashboard({ Object_id: id }),
                          cursor: "pointer",
                          icon: <img src="/images/database.png" alt="Data-Sources" />,
                          iconClass: "BottomIcon",
                          borderLeft: "10px solid #f6ca9f",
                          label: displayName || name,
                          description: <TextComponent label="" value={description} paragraph={true} />,
                          location: <TextComponent label="Connection" value={connectionName} />,
                          totalFields: <TextComponent label="Total Fields" value={fieldCount} />,
                          textTransform: "uppercase",
                          chips: [
                            {
                              text: type?.toLowerCase() === "csv" ? "Delimited" : type,
                              chipTextColor: type?.toLowerCase() === "csv" ? "#14769A" : "#20732C",
                              chipBGColor: type?.toLowerCase() === "csv" ? "#C7DDF2" : "#CAF2C7",
                            },
                            ...(datasetType === "tracked"
                              ? [
                                  {
                                    text: "Tracking history",
                                    chipTextColor: "#14769A",
                                    chipBGColor: "#C7DDF2",
                                  },
                                ]
                              : []),
                          ],
                        }}
                      />
                    </Grid>
                  );
                }
              )
            ) : !loading ? (
              <Grid sx={{ mb: 2, mt: 5 }} className={classes.NoData} size={12}>
                <Typography variant="h6" color={"error"} style={{ color: "#000000d9" }} textTransform="none">
                  No records found
                </Typography>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Tile;
